import axios from 'axios';
import LeadSource from '../entity/lead-source.entity';

export default class LeadSourceService {
  static readonly PATH_URL = '/api/v1/lead-sources';

  public static getLeadSources(): Promise<LeadSource[]> {
    return axios.get(this.PATH_URL)
      .then((response: any) => LeadSource.ofList(response.data));
  }

  public static create(leadSource: LeadSource): Promise<LeadSource> {
    return axios
      .post(this.PATH_URL, leadSource)
      .then((response: any) => LeadSource.of(response.data));
  }
}
